const maximo=199999
const minimo=100000
export{maximo,minimo}